/**
 * treatrx.providers.ts
 *
 * Resolving which provider the Prescriptions tab acts on.
 *
 * The legacy page passed `document.getElementById('ayvaDoctorSelect').value`
 * into loadPrescriptions (patient_details.php), so the id it used was always
 * the one the browser was showing — including the implicit first-option
 * fallback when PHP marked no <option> as selected.
 *
 * The V5 port drives a controlled <select> from `defaultAyvaDoctorID`, which
 * the API only fills when the logged-in user has their own aa_ayva_doctors
 * row. When that value matches no <option>, the browser still displays the
 * first provider while the state holds '' — so isDoctorGranted('') ran and the
 * tab showed "Allow Access" for a provider that had already granted it.
 * Resolving the id the same way the <select> does keeps the two in step.
 */
import type { PrescriptionProvider } from './prescriptions.service';

/** The provider id the <select> will actually display for this default. */
export function resolveVisibleProviderId(
  providers: PrescriptionProvider[] | undefined,
  defaultAyvaDoctorID: string | null | undefined,
): string {
  const list = providers ?? [];
  const wanted = defaultAyvaDoctorID ?? '';
  if (wanted && list.some((p) => p.ayvaDoctorID === wanted)) return wanted;
  return list[0]?.ayvaDoctorID ?? '';
}
